import React from "react";
import './Input.scss'

export function InputWrapper({ children }: { children: JSX.Element }){
    return <div className='input_wrapper'>{children}</div>
}